import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay } from "swiper/modules";

import "swiper/css";

import img1 from "../../../assets/img/esg/esgSeven/card1.png";
import img2 from "../../../assets/img/esg/esgSeven/card2.png";
import img3 from "../../../assets/img/esg/esgSeven/card3.png";
import img4 from "../../../assets/img/esg/esgSeven/card4.png";
import img5 from "../../../assets/img/esg/esgSeven/card5.png";
import img6 from "../../../assets/img/esg/esgSeven/card6.png";
import img7 from "../../../assets/img/esg/esgSeven/card7.png";
import img8 from "../../../assets/img/esg/esgSeven/card8.png";

function EsgSeven() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const breakpoints = {
    1200: {
      slidesPerView: 4,
    },
    1000: {
      spaceBetween: 20,
    },
    900: {
      slidesPerView: 3,
    },
    700: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="esgSeven" className={`esgSeven ${isVisible ? "visible" : ""}`}>
        <div className="esgSevenTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("esg_seven_title")}{" "}
            <span>{t("esg_seven_title_span")}</span>
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("esg_seven_text")}
          </p>
        </div>
        <Swiper
          slidesPerView={4}
          spaceBetween={40}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          speed={500}
          loop={true}
          modules={[Autoplay]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img1} alt="" />
              <p>
                {t("esg_seven_card1")}
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img2} alt="" />
              <p>
                {t("esg_seven_card2")}
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img3} alt="" />
              <p>
                {t("esg_seven_card3")}
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img4} alt="" />
              <p>
                {t("esg_seven_card4")}
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img6} alt="" />
              <p>
                {t("esg_seven_card5")}
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img7} alt="" />
              <p>
                {t("esg_seven_card6")}
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
              <img src={img8} alt="" />
              <p>
                {t("esg_seven_card7")}
              </p>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default EsgSeven;
